import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_REWARDS_ESSENCE_TIER_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import {
  GAMEPLAY_TIER_POOL_TIERS,
  QUALITY_POOL_TIERS,
  playerPoolTierSlug,
} from '@sorare/core/src/lib/playerPoolTiers';

import { COMPETITION_SEARCH_PARAM } from '#src/components/rewards/PoolCompetitionFilter/index.tsx';
import { useCraftingWithGameplayTier } from '#src/hooks/useCraftingWithGameplayTier.ts';

export const useCraftingPoolTiers = () =>
  useCraftingWithGameplayTier() ? GAMEPLAY_TIER_POOL_TIERS : QUALITY_POOL_TIERS;

export const useCraftingPoolPath = () => {
  const { generateSportContextPath } = useSportContext();
  const [firstTier] = useCraftingPoolTiers();

  return (rarity: Rarity, competitionSlug?: string) => {
    const pathname = generateSportContextPath(
      ANY_SPORT_REWARDS_ESSENCE_TIER_RARITY,
      { params: { tier: playerPoolTierSlug(firstTier), rarity } }
    );

    if (!competitionSlug) {
      return pathname;
    }

    return {
      pathname,
      search: `?${COMPETITION_SEARCH_PARAM}=${competitionSlug}`,
    };
  };
};
